import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { validateConfig } from './config/validation';
import ReactQueryProvider from './providers/ReactQueryProvider';

// Validate configuration before rendering
// Fails fast with clear error messages if misconfigured
validateConfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ReactQueryProvider>
      <App />
    </ReactQueryProvider>
  </React.StrictMode>
);
